export default __webpack_public_path__ + "static/media/outfordelivery.f83e955e.svg";